/**
 * Convert array of objects to CSV string
 * @param data Array of objects to convert
 * @param options Configuration options for CSV conversion
 * @returns CSV string
 */
export var convertToCSV = function convertToCSV(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!data || data.length === 0) {
    return '';
  }

  var _options$headers = options.headers,
      headers = _options$headers === void 0 ? Object.keys(data[0]) : _options$headers,
      _options$headerMappin = options.headerMapping,
      headerMapping = _options$headerMappin === void 0 ? {} : _options$headerMappin,
      _options$includeHeade = options.includeHeaders,
      includeHeaders = _options$includeHeade === void 0 ? true : _options$includeHeade,
      _options$delimiter = options.delimiter,
      delimiter = _options$delimiter === void 0 ? ',' : _options$delimiter; // Escape CSV values (handle commas, quotes, and line breaks)

  var escapeCSVValue = function escapeCSVValue(value) {
    if (value === null || value === undefined) {
      return '';
    }

    var stringValue = String(value); // If the value contains comma, quote, or newline, wrap it in quotes and escape inner quotes

    if (stringValue.includes(delimiter) || stringValue.includes('"') || stringValue.includes('\n')) {
      return "\"".concat(stringValue.replace(/"/g, '""'), "\"");
    }

    return stringValue;
  }; // Build CSV header row


  var csvRows = [];

  if (includeHeaders) {
    var headerRow = headers.map(function (header) {
      return escapeCSVValue(headerMapping[header] || header);
    }).join(delimiter);
    csvRows.push(headerRow);
  } // Build CSV data rows


  data.forEach(function (row) {
    var values = headers.map(function (header) {
      var value = row[header];
      return escapeCSVValue(value);
    });
    csvRows.push(values.join(delimiter));
  }); // Prepend UTF-8 BOM for Excel compatibility

  return "\uFEFF" + csvRows.join('\n');
};
/**
 * Download CSV file to user's computer
 * @param csvContent CSV string content
 * @param filename Name of the file to download
 */

export var downloadCSVFile = function downloadCSVFile(csvContent) {
  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data.csv';
  var blob = new Blob([csvContent], {
    type: 'text/csv;charset=utf-8;'
  });
  var link = document.createElement('a');
  var url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
/**
 * Convert generic data to CSV and download
 * @param data Array of objects
 * @param filename Name of the file
 * @param headers Optional custom headers
 */

export var exportDataAsCSV = function exportDataAsCSV(data) {
  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'export.csv';
  var headers = arguments.length > 2 ? arguments[2] : undefined;

  if (!data || data.length === 0) {
    console.warn('No data to export');
    return;
  }

  var csvHeaders = headers || Object.keys(data[0]);
  var csvContent = convertToCSV(data, {
    headers: csvHeaders,
    includeHeaders: true,
    delimiter: ','
  }); // Ensure BOM is present (in case convertToCSV is overridden)

  var contentWithBOM = csvContent.startsWith("\uFEFF") ? csvContent : "\uFEFF" + csvContent;
  downloadCSVFile(contentWithBOM, filename);
};